import { useAppDispatch } from "../../../app/hooks";
import { airportsSwitch } from "../searchFlightsSlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowsAltV } from "@fortawesome/free-solid-svg-icons/faArrowsAltV";
import React from "react";
import { useTranslation } from "react-i18next";

function SwitchAirportsButton() {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const onChange = () => dispatch(airportsSwitch());

  return (
    <>
      <button
        className="button is-light is-hidden-mobile"
        aria-label={t("CHANGE_DIRECTION")}
        onClick={() => onChange()}
      >
        <span className="icon">
          <FontAwesomeIcon icon={faArrowsAltV} />
        </span>
      </button>
      <button
        className="button is-small is-light is-hidden-tablet"
        aria-label={t("CHANGE_DIRECTION")}
        onClick={() => onChange()}
      >
        <span className="icon">
          <FontAwesomeIcon icon={faArrowsAltV} />
        </span>
        <span>{t("CHANGE_DIRECTION")}</span>
      </button>
    </>
  );
}

export default SwitchAirportsButton;
